import type { Chapter } from '@/components/layout/Section';

/** Chapter anchors shown in the mobile hamburger panel (Figma UI Mobile). */
export const MOBILE_NAV_CHAPTERS = [
  'introduction',
  'state',
  'pressure',
  'response',
] as const satisfies readonly Chapter[];
